import React from 'react';
import { useHistory } from 'react-router-dom';
import {
  Card,
  CardContent,
  Stack,
  Grid2 as Grid,
  Typography,
  Button,
  Divider
} from '@mui/material';
import { Start as StartIcon } from '@mui/icons-material';

import { AcceptAllReviewsButton } from './acceptAllReviewsButton.jsx';
import { PageStatusDialog } from './pageStatusDialog.jsx';
import { GRID_SPACING, GRID_ROW_FULL_WIDTH_ROW } from '../constants.js';
import { KPISection } from './kpiSection.jsx';
import { useClientReviewLandingPage } from '../hooks/useLandingPageService.js';
import { PAGE_STATUSES } from '../hooks/useWorkPageDetailService.js';
import { ReviewSearchForm } from './reviewSearchForm.jsx';

function ClientReviewLandingPage({ service }) {
  const history = useHistory();
  const [pageState, pageApi] = useClientReviewLandingPage(service);

  if (pageState.status === PAGE_STATUSES.UNINITIALIZED) {
    return (<div>Initializing Page...</div>);
  }

  if (pageState.status === PAGE_STATUSES.ERROR) {
    return (<div>Page Error: {pageState.errorMessage}</div>);
  }

  return (
    <Grid container spacing={GRID_SPACING}>
      <Grid
        size={GRID_ROW_FULL_WIDTH_ROW}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Typography variant="h2">
          Medicare RAM Client Review Landing Page
        </Typography>
      </Grid>

      <Grid size={GRID_ROW_FULL_WIDTH_ROW}>
        <KPISection {...pageState.kpiSection} />
      </Grid>

      <Grid size={GRID_ROW_FULL_WIDTH_ROW}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Card sx={{ width: '90%', height: '100%' }}>
          <CardContent sx={{ display: 'flex', justifyContent: 'center' }}>
            <ReviewSearchForm
              changeConfigurationValue={pageApi.changeSearchConfiguration}
              currentConfiguration={pageState.reviewSearch.searchConfiguration}
              handleSearch={pageApi.searchReviews}
              isRequestInProgress={pageState.isRequestInProgress}
              numberOfMatches={pageState.reviewSearch.numberOfMatches}
            />

            <Divider
              sx={{ marginInline: '8em' }}
              variant="fullWidth"
              orientation="vertical"
              flexItem
            />

            <Stack spacing={2}>
              <Typography variant="h5">Operations</Typography>
              <Button
                variant="contained"
                disableElevation
                startIcon={<StartIcon />}
                onClick={() => pageApi.beginWork(history.push)}
              >
                Start Work
              </Button>

              <AcceptAllReviewsButton
                handleAcceptAllReviews={pageApi.acceptAllReviews}
              />
            </Stack>
          </CardContent>
        </Card>
      </Grid>

      <PageStatusDialog isOpen={pageState.isRequestInProgress} />
    </Grid>
  );
}

export { ClientReviewLandingPage };
